export interface AnimeItem {
  id: string;
  title: string;
  titleJa: string;
  cover: string;
  category: string;
  score: number;
  episode: string;
  year: number;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  updateTime: string;
}

export const animeList: AnimeItem[] = [
  {
    id: 'anime-001',
    title: '进击的巨人 最终季',
    titleJa: '進撃の巨人 The Final Season',
    cover: 'https://readdy.ai/api/search-image?query=Attack%20on%20Titan%20anime%20poster%20style%2C%20epic%20soldiers%20with%20wings%20of%20freedom%20emblem%2C%20dramatic%20lighting%2C%20dark%20atmosphere%2C%20cinematic%20composition%2C%20professional%20anime%20art%2C%20clean%20background%20with%20warm%20tones&width=600&height=840&seq=anime-cover-001&orientation=portrait',
    category: 'riman',
    score: 9.8,
    episode: '全16话',
    year: 2023,
    description: '艾伦·耶格尔为了追求自由，率领调查兵团与马莱展开最终决战。巨人之力的秘密即将揭晓，人类命运的齿轮开始转动。',
    tags: ['热血', '战斗', '末世', '史诗'],
    isHot: true,
    isNew: false,
    updateTime: '2024-01-15',
  },
  {
    id: 'anime-002',
    title: '鬼灭之刃 游郭篇',
    titleJa: '鬼滅の刃 遊郭編',
    cover: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%2C%20beautiful%20kimono%20characters%20with%20swords%2C%20vibrant%20night%20scene%2C%20traditional%20Japanese%20architecture%2C%20colorful%20neon%20lights%2C%20professional%20anime%20illustration%2C%20clean%20composition&width=600&height=840&seq=anime-cover-002&orientation=portrait',
    category: 'riman',
    score: 9.6,
    episode: '全11话',
    year: 2022,
    description: '炭治郎一行人潜入吉原游郭，追踪隐藏在此的上弦之陆。绚烂灯影之下，与恶鬼的惨烈对决正式开启。',
    tags: ['热血', '战斗', '和风', '冒险'],
    isHot: true,
    isNew: false,
    updateTime: '2024-01-10',
  },
  {
    id: 'anime-003',
    title: '间谍过家家',
    titleJa: 'SPY×FAMILY',
    cover: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%2C%20happy%20family%20portrait%20with%20spy%20father%20assassin%20mother%20and%20telepath%20daughter%2C%20warm%20and%20playful%20atmosphere%2C%20pastel%20colors%2C%20professional%20anime%20art%2C%20clean%20minimalist%20background&width=600&height=840&seq=anime-cover-003&orientation=portrait',
    category: 'riman',
    score: 9.5,
    episode: '全25话',
    year: 2022,
    description: '为了执行秘密任务，间谍"黄昏"组建了一个临时家庭。但他不知道的是，"妻子"是杀手，"女儿"是超能力者！',
    tags: ['搞笑', '日常', '温馨', '特工'],
    isHot: true,
    isNew: true,
    updateTime: '2024-02-01',
  },
  {
    id: 'anime-004',
    title: '咒术回战 第二季',
    titleJa: '呪術廻戦 第2期',
    cover: 'https://readdy.ai/api/search-image?query=Jujutsu%20Kaisen%20anime%20poster%2C%20sorcerer%20characters%20with%20cursed%20energy%20effects%2C%20dynamic%20action%20pose%2C%20dark%20supernatural%20theme%2C%20purple%20and%20black%20color%20scheme%2C%20professional%20anime%20art%2C%20clean%20composition&width=600&height=840&seq=anime-cover-004&orientation=portrait',
    category: 'riman',
    score: 9.4,
    episode: '全23话',
    year: 2023,
    description: '怀玉篇与涩谷事变篇交错上演。五条悟与夏油杰的青春往事，以及涩谷那场惊天动地的战斗正式开幕。',
    tags: ['热血', '战斗', '超能力', '黑暗'],
    isHot: true,
    isNew: true,
    updateTime: '2024-02-05',
  },
  {
    id: 'anime-005',
    title: '葬送的芙莉莲',
    titleJa: '葬送のフリーレン',
    cover: 'https://readdy.ai/api/search-image?query=Frieren%20anime%20poster%2C%20elf%20mage%20character%20walking%20through%20beautiful%20fantasy%20landscape%2C%20nostalgic%20and%20melancholic%20atmosphere%2C%20soft%20golden%20light%2C%20professional%20anime%20art%2C%20serene%20composition&width=600&height=840&seq=anime-cover-005&orientation=portrait',
    category: 'riman',
    score: 9.7,
    episode: '全28话',
    year: 2023,
    description: '勇者一行击败魔王后，长寿的精灵魔法使芙莉莲踏上"了解人类"的旅途。一段关于时间、生命与羁绊的静美故事。',
    tags: ['治愈', '奇幻', '冒险', '哲学'],
    isHot: true,
    isNew: false,
    updateTime: '2024-02-08',
  },
  {
    id: 'anime-006',
    title: '时光代理人 第二季',
    titleJa: '時光代理人 第二期',
    cover: 'https://readdy.ai/api/search-image?query=Link%20Click%20Chinese%20anime%20poster%2C%20two%20young%20men%20in%20modern%20city%2C%20mysterious%20time%20travel%20theme%2C%20urban%20night%20scene%2C%20neon%20lights%2C%20professional%20donghua%20art%20style%2C%20clean%20composition&width=600&height=840&seq=anime-cover-006&orientation=portrait',
    category: 'guoman',
    score: 9.3,
    episode: '全12话',
    year: 2023,
    description: '程小时与陆光继续经营时光照相馆，通过照片进入过去改变命运。但这一次，他们面对的敌人远比想象中更强大。',
    tags: ['悬疑', '奇幻', '都市', '国产'],
    isHot: true,
    isNew: true,
    updateTime: '2024-01-28',
  },
  {
    id: 'anime-007',
    title: '雾山五行',
    titleJa: '霧山五行',
    cover: 'https://readdy.ai/api/search-image?query=Fog%20Hill%20of%20Five%20Elements%20Chinese%20anime%20poster%2C%20martial%20arts%20warrior%20with%20ink%20wash%20painting%20style%2C%20traditional%20Chinese%20aesthetic%2C%20dynamic%20action%2C%20elegant%20brushwork%2C%20professional%20donghua%20art&width=600&height=840&seq=anime-cover-007&orientation=portrait',
    category: 'guoman',
    score: 9.5,
    episode: '全4话',
    year: 2023,
    description: '上古时期，妖兽横行。雾山五行以水墨画般的气势与妖兽展开惊天动地的对决，国风美学巅峰之作。',
    tags: ['战斗', '国风', '神话', '水墨'],
    isHot: true,
    isNew: false,
    updateTime: '2024-01-20',
  },
  {
    id: 'anime-008',
    title: '铃芽之旅',
    titleJa: 'すずめの戸締まり',
    cover: 'https://readdy.ai/api/search-image?query=Suzume%20anime%20movie%20poster%2C%20young%20girl%20and%20mysterious%20young%20man%20traveling%20through%20beautiful%20Japanese%20landscapes%2C%20magical%20doors%2C%20cinematic%20lighting%2C%20professional%20anime%20film%20art%2C%20clean%20composition&width=600&height=840&seq=anime-cover-008&orientation=portrait',
    category: 'juchang',
    score: 9.2,
    episode: '剧场版',
    year: 2023,
    description: '17岁少女铃芽遇见寻找"门"的青年草太，两人踏上关闭灾祸之门的旅程。新海诚导演最新力作，震撼心灵的冒险之旅。',
    tags: ['奇幻', '冒险', '治愈', '电影'],
    isHot: true,
    isNew: false,
    updateTime: '2024-01-12',
  },
  {
    id: 'anime-009',
    title: '排球少年!! 垃圾场的决战',
    titleJa: 'ハイキュー!! ゴミ捨て場の決戦',
    cover: 'https://readdy.ai/api/search-image?query=Haikyuu%20anime%20movie%20poster%2C%20volleyball%20players%20in%20intense%20match%2C%20dynamic%20sports%20action%2C%20team%20spirit%2C%20bright%20gymnasium%20lighting%2C%20professional%20anime%20art%2C%20energetic%20composition&width=600&height=840&seq=anime-cover-009&orientation=portrait',
    category: 'juchang',
    score: 9.6,
    episode: '剧场版',
    year: 2024,
    description: '乌野高校与音驹高校，这对宿命的对手终于在全国大赛的舞台上正面交锋。垃圾场的决战，就此揭幕！',
    tags: ['运动', '热血', '青春', '电影'],
    isHot: false,
    isNew: true,
    updateTime: '2024-02-10',
  },
  {
    id: 'anime-010',
    title: '龙猫',
    titleJa: 'となりのトトロ',
    cover: 'https://readdy.ai/api/search-image?query=My%20Neighbor%20Totoro%20Studio%20Ghibli%20poster%2C%20two%20little%20girls%20with%20big%20fluffy%20Totoro%20in%20forest%2C%20nostalgic%20rural%20Japan%2C%20magical%20and%20heartwarming%20atmosphere%2C%20soft%20watercolor%20style%2C%20clean%20composition&width=600&height=840&seq=anime-cover-010&orientation=portrait',
    category: 'jingdian',
    score: 9.7,
    episode: '剧场版',
    year: 1988,
    description: '小月和小梅随父亲搬到乡下，意外邂逅了森林中的神奇生物龙猫。宫崎骏不朽经典，治愈无数心灵的童话。',
    tags: ['治愈', '奇幻', '经典', '吉卜力'],
    isHot: false,
    isNew: false,
    updateTime: '2024-01-08',
  },
  {
    id: 'anime-011',
    title: '航海王',
    titleJa: 'ONE PIECE',
    cover: 'https://readdy.ai/api/search-image?query=One%20Piece%20anime%20poster%2C%20pirate%20crew%20sailing%20on%20ship%2C%20adventurous%20grand%20line%20ocean%2C%20colorful%20characters%2C%20epic%20adventure%20theme%2C%20professional%20anime%20art%2C%20clean%20bright%20composition&width=600&height=840&seq=anime-cover-011&orientation=portrait',
    category: 'jingdian',
    score: 9.5,
    episode: '连载中',
    year: 1999,
    description: '为了成为海贼王，路飞和他的草帽海贼团踏上了伟大航路的大冒险。连载二十余年，热血与感动从未停歇。',
    tags: ['热血', '冒险', '友情', '长篇'],
    isHot: false,
    isNew: false,
    updateTime: '2024-02-12',
  },
  {
    id: 'anime-012',
    title: '灵能百分百 第三季',
    titleJa: 'モブサイコ100 Ⅲ',
    cover: 'https://readdy.ai/api/search-image?query=Mob%20Psycho%20100%20anime%20poster%2C%20psychic%20middle%20school%20boy%20with%20explosive%20energy%2C%20psychedelic%20color%20effects%2C%20unique%20art%20style%2C%20dynamic%20supernatural%20theme%2C%20professional%20anime%20illustration&width=600&height=840&seq=anime-cover-012&orientation=portrait',
    category: 'rexue',
    score: 9.4,
    episode: '全12话',
    year: 2022,
    description: '影山茂夫——看似平凡的超能力少年，为了保护重要的人，爆发百分百的勇气与力量。ONE老师又一力作完美落幕。',
    tags: ['超能力', '战斗', '成长', '热血'],
    isHot: false,
    isNew: false,
    updateTime: '2024-01-25',
  },
  {
    id: 'anime-013',
    title: '辉夜大小姐想让我告白',
    titleJa: 'かぐや様は告らせたい',
    cover: 'https://readdy.ai/api/search-image?query=Kaguya%20sama%20Love%20is%20War%20anime%20poster%2C%20rich%20school%20girl%20and%20boy%20in%20romantic%20comedy%20pose%2C%20elegant%20student%20council%20room%2C%20pastel%20pink%20and%20white%20colors%2C%20professional%20anime%20art&width=600&height=840&seq=anime-cover-013&orientation=portrait',
    category: 'lianai',
    score: 9.3,
    episode: '全37话+OVA',
    year: 2022,
    description: '在名门秀知院学园，学生会会长与副会长之间的"恋爱头脑战"每天都在上演——谁先告白谁就输了！',
    tags: ['恋爱', '搞笑', '校园', '日常'],
    isHot: false,
    isNew: false,
    updateTime: '2024-01-18',
  },
  {
    id: 'anime-014',
    title: '石纪元',
    titleJa: 'Dr.STONE',
    cover: 'https://readdy.ai/api/search-image?query=Dr%20Stone%20anime%20poster%2C%20scientist%20boy%20rebuilding%20civilization%20in%20stone%20world%2C%20science%20and%20adventure%20theme%2C%20nature%20and%20technology%20contrast%2C%20bright%20vibrant%20colors%2C%20professional%20anime%20art&width=600&height=840&seq=anime-cover-014&orientation=portrait',
    category: 'kehuan',
    score: 9.1,
    episode: '全35话',
    year: 2023,
    description: '全人类被神秘光线石化，千年后苏醒的天才少年千空用科学的力量从零开始重建人类文明！',
    tags: ['科幻', '冒险', '科学', '热血'],
    isHot: false,
    isNew: false,
    updateTime: '2024-01-22',
  },
  {
    id: 'anime-015',
    title: '夏日重现',
    titleJa: 'サマータイムレンダ',
    cover: 'https://readdy.ai/api/search-image?query=Summer%20Time%20Rendering%20anime%20poster%2C%20island%20mystery%20with%20shadow%20doppelgangers%2C%20suspenseful%20atmosphere%2C%20summer%20coastal%20setting%2C%20dark%20and%20intriguing%2C%20professional%20anime%20art&width=600&height=840&seq=anime-cover-015&orientation=portrait',
    category: 'xuanyi',
    score: 9.2,
    episode: '全25话',
    year: 2022,
    description: '回到故乡小岛的少年发现岛上隐藏着可怕的"影子病"，为了拯救挚爱之人，他必须在无尽的夏日循环中找出真相。',
    tags: ['悬疑', '轮回', '推理', '惊悚'],
    isHot: false,
    isNew: false,
    updateTime: '2024-01-16',
  },
  {
    id: 'anime-016',
    title: '一人之下 第五季',
    titleJa: '一人之下 第五期',
    cover: 'https://readdy.ai/api/search-image?query=The%20Outcast%20Chinese%20donghua%20poster%2C%20martial%20arts%20characters%20with%20supernatural%20powers%2C%20modern%20Chinese%20urban%20setting%2C%20dynamic%20action%2C%20traditional%20elements%20blend%2C%20professional%20donghua%20art&width=600&height=840&seq=anime-cover-016&orientation=portrait',
    category: 'guoman',
    score: 9.0,
    episode: '全12话',
    year: 2023,
    description: '张楚岚与宝儿姐继续在异人世界中追寻真相，唐门往事与三十六贼的秘密逐渐浮出水面。国漫巅峰之作。',
    tags: ['战斗', '奇幻', '国产', '江湖'],
    isHot: false,
    isNew: true,
    updateTime: '2024-02-03',
  },
];

export const getAnimeById = (id: string): AnimeItem | undefined => {
  return animeList.find((a) => a.id === id);
};

export const getAnimeByCategory = (category: string): AnimeItem[] => {
  return animeList.filter((a) => a.category === category);
};

export const getHotAnime = (): AnimeItem[] => {
  return animeList.filter((a) => a.isHot);
};

export const getNewAnime = (): AnimeItem[] => {
  return animeList.filter((a) => a.isNew);
};